module.exports = __webpack_public_path__ + "499b4f3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Pediatria/25241.jpg
// module id = 1330
// module chunks = 0 1